import { render, staticRenderFns } from "./BasicsEnergyData.vue?vue&type=template&id=c386ce0a&scoped=true"
import script from "./BasicsEnergyData.vue?vue&type=script&lang=js"
export * from "./BasicsEnergyData.vue?vue&type=script&lang=js"
import style0 from "./BasicsEnergyData.vue?vue&type=style&index=0&id=c386ce0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c386ce0a",
  null
  
)

export default component.exports